import fetchServer from "../helpers/api/fetchServer";
import fetchServerUpdateImage from "../helpers/api/fetchServerUpdateImage";

export const createPlatform = async ({
  name,
  shortName,
  url,
  postIsCalled,
  adPlatformId,
  hasPlacement,
  isCallToActionFreeText,
}) => {
  const method = "POST";
  const urlAPI = "/api/platforms";
  const body = {
    name,
    shortName,
    url,
    postIsCalled: postIsCalled || null,
    adPlatform: adPlatformId || null,
    hasPlacement,
    isCallToActionFreeText,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const getPlatforms = async () => {
  const method = "GET";
  const urlAPI = "/api/platforms";
  return await fetchServer({ method, urlAPI });
};

export const getPlatformsByAdPlatform = async (adPlatformId) => {
  const method = "GET";
  const urlAPI = `/api/platforms?adPlatform=${adPlatformId}`;
  return await fetchServer({ method, urlAPI });
};

export const getPlatform = async (id) => {
  const method = "GET";
  const urlAPI = `/api/platforms/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const updatePlatform = async ({
  id,
  name,
  shortName,
  url,
  postIsCalled,
  adPlatformId,
  hasPlacement,
  isCallToActionFreeText,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/platforms/${id}`;
  const body = {
    name,
    shortName,
    url,
    postIsCalled: postIsCalled || null,
    adPlatform: adPlatformId || null,
    hasPlacement,
    isCallToActionFreeText,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const updatePlatformLogo = async ({ id, formData }) => {
  const urlAPI = `/api/platforms/${id}/logo`;
  return await fetchServerUpdateImage({ urlAPI, formData });
};

export const deletePlatformLogo = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/platforms/${id}/logo`;
  return await fetchServer({ method, urlAPI });
};

export const deletePlatform = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/platforms/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const restorePlatform = async (id) => {
  const method = "POST";
  const urlAPI = `/api/platforms/${id}/restore`;
  return await fetchServer({ method, urlAPI });
};

export const deletePlatforms = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/platforms/bulk-delete";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};

export const restorePlatforms = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/platforms/bulk-restore";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};  
